// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Container} from '../../container/Container'
import {Button} from '../../button/Button'

@Component({
    components: {
        Button,
        Container
    },
    mixins: [
        template,
    ]
})
export class HeaderOverlay extends Vue {

    public classes: string[] = []

    @Prop()
    public value!: string

    @Prop({type: Object})
    public item!: any

    public created () {

        window.addEventListener('click', this.closeOverlay)
    }

    public destroyed() {
        window.removeEventListener('click', this.closeOverlay)
    }

    public closeOverlay(e: any) {

        if (this.item.id != this.value) return

        if (!e || e.target.contains(this.$el) || !this.$el.contains(e.target)) {

            this.$emit('input')
        }
    }
}